import * as React from "react"
import {
  Create,
} from "react-admin"
import PrintingMethodForm from "./PrintingMethodForm"

const PrintingMethodTitle = () => {
  return <span>{'印製方式'}</span>;
};

const PrintingMethodCreate = () => {
  return (
    <Create 
      title={<PrintingMethodTitle/>}
    >
      <PrintingMethodForm 
        formType="create"
      />
    </Create>
  )
}

export default PrintingMethodCreate